require('dotenv').config();
/* eslint-disable max-len */

module.exports = {

  port: process.env.PORT || 3000,  // Node.js app
  host: process.env.WEBSITE_HOSTNAME || `localhost:3000`,
  trustProxy: process.env.TRUST_PROXY || 'loopback',// https://expressjs.com/en/guide/behind-proxies.html
  siteUrl: process.env.SITE_URL || 'https://www.basrecovery.com', // SITE URL

  api: { // API Gateway
    clientUrl: process.env.API_CLIENT_URL || '', // API URL to be used in the client-side code
    serverUrl: process.env.API_SERVER_URL || `http://localhost:${process.env.PORT || 3000}`,// API URL to be used in the server-side code
    apiEndpoint: process.env.API_ENDPOINT_URL || 'https://www.basrecovery.com/api',
    socketUrl: process.env.SOCKET_URL || 'https://www.basrecovery.com'
  },

  databaseUrl: process.env.DATABASE_URL, // Database

  locales: [ // default locale is the first one
    /* @intl-code-template '${lang}-${COUNTRY}', */
    'en-US',
    'es',
    'fr-FR',
    'ru-RU',
    'ja-JP',
    'id-ID',
    'hr-HR',
    'zh-CN',
    'sv-SE',
    'ar'  /* @intl-code-template-end */
  ],

  licenseuploadDir: process.env.LICENSE_UPLOAD_DIR || '/images/license/', // Licence Upload

  profilePhotouploadDir: process.env.PROFILE_PHOTO_UPLOAD_DIR || '/images/avatar/', // Profile photo upload

  categoryUploadDir: process.env.CATEGORY_PHOTO_UPLOAD_DIR || '/images/category/',  // category photo upload

  logoUploadDir: process.env.LOGO_PHOTO_UPLOAD_DIR || '/images/logo/',   // Logo photo upload

  ogImageUploadDir: process.env.OG_IMAGE_UPLOAD_DIR || '/images/ogImage/',   // OG image upload

  homepageUploadDir: process.env.HOMEPAGE_UPLOAD_DIR || '/images/homepage/', // homepage photo upload

  staticpageUploadDir: process.env.STATICPAGE_UPLOAD_DIR || '/images/staticpage/',  // staticpage photo upload

  contentPageUploadDir: process.env.CONTENTPAGE_UPLOAD_DIR || '/images/contentPage/',   //Content page photo upload

  faviconUploadDir: process.env.FAVICON_UPLOAD_DIR || '/images/favicon/',   // favicon upload

  subCategoryUploadDir: process.env.SUB_CATEGORY_PHOTO_UPLOAD_DIR || '/images/sub-category/',  // subCategory photo upload

  documentUploadDir: process.env.DOCUMENT_UPLOAD_DIR || '/images/document/',  // Document Upload

  homePageCategoryBannerUploadDir: process.env.HOMEPAGE_CATEGORY_BANNER_UPLOAD_DIR || '/images/homePageCategory/banner/', //homepagecategory images

  homePageCategoryLogoUploadDir: process.env.HOMEPAGE_CATEGORY_LOGO_UPLOAD_DIR || '/images/homePageCategory/logo/',

  promoCodeImageUploadDir: process.env.PROMOCODE_DIR || '/images/promocode/',   //Promocode image directoy

  reviewImageUploadDir: process.env.REVIEW_PHOTO_UPLOAD_DIR || '/images/reviewImage/',

  toneUploadDir: process.env.TONE_UPLOAD_DIR || '/images/tone/',

  cmsUploadDir: process.env.CMS_UPLOAD_DIR || '/images/cms/',

  googleMapAPI: 'AIzaSyCqncfIOj2IVXcR47mJLstWjA4M0_mcDb4',   //Google map api key
  googleMapServerKey: process.env.GOOGLE_MAP_SERVER_KEY,

  analytics: {   // Web analytics https://analytics.google.com/
    googleTrackingId: process.env.GOOGLE_TRACKING_ID, // UA-XXXXX-X
  },

  payment: {  // Payment - Stripe
    stripe: {
      secretKey: process.env.STRIPE_SECRET,
    }
  },

  auth: {   // Authentication
    jwt: { secret: process.env.JWT_SECRET },

    facebook: { // https://developers.facebook.com/
      id: process.env.FACEBOOK_APP_ID,
      secret:
        process.env.FACEBOOK_APP_SECRET,
    },

    google: {  // https://cloud.google.com/console/project
      id:
        process.env.GOOGLE_CLIENT_ID,
      secret: process.env.GOOGLE_CLIENT_SECRET,
    },

    twitter: { // https://apps.twitter.com/
      key: process.env.TWITTER_CONSUMER_KEY,
      secret:
        process.env.TWITTER_CONSUMER_SECRET,
    },
  },

  unitTypes: {
    km: { value: 'metric', convertFromMeter: 1000 },
    mile: { value: 'imperial', convertFromMeter: 1609 }
  },

  cronTimezone: process.env.CRON_TIMEZONE

};
